<section class="our-services cmsPage">
      <div class="cmsHeaderImg"></div>
      <div class="PageContent">
            <div class="scrollByHeader">
                  <div class="max-1200">
                        <div fxLayout="row" class="scH">
                              <div fxFlex="25%" fxLayout="column" fxLayoutAlign="center center">
                                    <h4>Build your order</h4>
                                    <div class="active" (click)="scrollTo('section1')">
                                          <span class="circleSB">1</span>
                                    </div>
                              </div>
                              <div fxFlex="25%" fxLayout="column" fxLayoutAlign="center center">
                                    <h4>Choose how often</h4>
                                    <div class="lineL" (click)="scrollTo('section2')">
                                          <span class="circleSB">2</span>
                                    </div>
                              </div>
                              <div fxFlex="25%" fxLayout="column" fxLayoutAlign="center center">
                                    <h4>We deliver</h4>
                                    <div class="lineL" (click)="scrollTo('section3')">
                                          <span class="circleSB">3</span>
                                    </div>
                              </div>
                              <div fxFlex="25%" fxLayout="column" fxLayoutAlign="center center">
                                    <h4>You enjoy!</h4>
                                    <div class="lineL" (click)="scrollTo('section4')">
                                          <span class="circleSB">4</span>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
            <section class="woodBg" id="section1">
                  <div class="max-1200">
                        <div fxLayout="row">
                              <div fxFlex="50">
                                    <div class="contentL">
                                          <div class="text-center active"><span class="circle">1</span></div>
                                          <h4 class="Stitle">BUILD YOUR FRESH ORDER</h4>
                                          <p class="para">Once you are registered it’s time to begin having <b>real food</b> from our farms and producers delivered right to your front door! Choose from over 500 products: dairy, meats, produce, bakery items, and pantry products—whatever you select you can be sure that the products are natural and sourced from producers that share our passion for our food-system. </p>
                                    </div>
                              </div>
                              <div fxFlex="50" class="text-left" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                                    <img src="https://hudsonmilk.com/images/3/cms/hiw-1.jpg" alt="">
                              </div>
                              <div fxFlex="50" class="text-left" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                                    <img src="assets/hudson/files/images/3/content-images/hiw-1.jpg" alt="">
                              </div>
                        </div>
                  </div>
            </section>
            <section class="mb-30" id="section2">
                  <div class="max-1200">
                        <div fxLayout="row" class="ltor">
                              <div fxFlex="45" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                                    <img src="https://hudsonmilk.com/images/3/cms/hiw-2.jpg" alt="">
                              </div>
                              <div fxFlex="45" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                                    <img src="assets/hudson/files/images/3/content-images/hiw-2.jpg" alt="">
                              </div>
                              <div fxFlex="55">
                                    <div class="contentL" fxLayout="column" fxLayoutAlign="center center">
                                          <div class="text-center"><span class="circle">2</span></div>
                                          <h4 class="Stitle">CHOOSE HOW OFTEN</h4>
                                          <p class="para">Know you want a regular, recurring order? You can set up weekly, every other week, or monthly. Get some products weekly and others biweekly. Or, order as you go. Frequency is entirely up to you! No contracts, no hassle. Simply what you want, when you want it.</p>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <section class="mb-30" id="section3">
                  <div class="max-1200">
                        <div fxLayout="row" class="ltor">
                              <div fxFlex="55"> 
                                    <div class="contentL" fxLayout="column" fxLayoutAlign="center center">
                                          <div class="text-center"><span class="circle">3</span></div>
                                          <h4 class="Stitle">WE DELIVER</h4>
                                          <p class="para">All you need to do is leave an insulated cooler (or milk box) outside the night before your delivery. Our milkmen will do the rest! On hot summer nights we recommend you leave frozen ice packs in the cooler, and on winter nights where temps fall below freezing, we recommend leaving towels to help keep the milk from freezing.</p>
                                    </div>
                              </div>
                              <div fxFlex="45" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                                    <img src="https://hudsonmilk.com/images/3/cms/hiw-3.jpg" alt="">
                              </div>
                              <div fxFlex="45" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                                    <img src="assets/hudson/files/images/3/content-images/hiw-3.jpg" alt="">
                              </div>
                        </div>
                  </div>
            </section>
            <section class="mb-30" id="section4">
                  <div class="max-1200">
                        <div fxLayout="row" class="ltor">
                              <div fxFlex="45" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                                    <img src="https://hudsonmilk.com/images/3/cms/hiw-4-hudson.jpg" alt="">
                              </div>
                              <div fxFlex="45" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                                    <img src="assets/hudson/files/images/3/content-images/hiw-4.jpg" alt="">
                              </div>
                              <div fxFlex="55">
                                    <div class="contentL" fxLayout="column" fxLayoutAlign="center center">
                                          <div class="text-center"><span class="circle">4</span></div>
                                          <h4 class="Stitle">YOU ENJOY!</h4>
                                          <p class="para">Wake up to find farm-fresh goodness at your door! Now it’s time for you and your family to enjoy local, non-processed, farm-fresh products. You'll taste and LOVE the difference!</p>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
      </div>
      <section class="btnContent">
            <div class="max-1300 text-center" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                  <img class="imgRes" src="https://hudsonmilk.com/images/3/cms/invoice_logo.jpg" alt="logo">
                  <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
                  <img src="https://hudsonmilk.com/images/3/cms/hr-line.svg" alt="design">
                  <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
            </div>
            <div class="max-1300 text-center" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                  <img class="imgRes" src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" alt="logo">
                  <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
                  <img src="assets/hudson/files/images/3/content-images/hr-line.svg" alt="design">
                  <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
              </div>
      </section>
</section>      